export default "__VITE_ASSET__CqFyQ5Fx__"